module.exports = __webpack_public_path__ + "assets/ProfissionalMestrado.5e58c2a6c0650b9f0701b1ca8363b28c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/ProfissionalMestrado.png
 ** module id = 485
 ** module chunks = 0
 **/